import React, { Component } from 'react';
import {STATUS_NAME} from "../../../../wpconfig";
import {getDateYMD} from "../../../../utils/functions";

class Item extends Component {
    constructor(props) {
        super(props);

        this.state = {
          url : "admin.php?" + window.location.href.split("?")[1],
        }
    }

    componentDidUpdate() {
      setTimeout(() => {
        this.setState({
          'url' : "admin.php?" + window.location.href.split("?")[1]
        })
      }, 0);
    }
    // linkDetail = (event) => {
    //   event.preventDefault()
    //
    //   window.location.href = "admin.php?" + window.location.href.split("?")[1] + "&record_id=" + this.props.record.scholar_id;
    // }
    
    render() {
        const record = this.props.record;
        return (
            <tr>
                <td scope="row">
                  <input type="checkbox" className="ml-0" value={record.scholar_id}
                         checked={this.props.checked}
                         onChange={this.props.onRecordCheck}/>
                </td>
                <td>{this.props.no}</td>
                <td>{record.scholar_id}</td>
                <td>
                  <a href={this.state.url + "&record_id=" + this.props.record.scholar_id} className="pr-2">
                    <strong>{record.scholar_name}</strong></a>
                    <span>{record.school_no}</span>
                </td>
                <td>{record.col_name}</td>
                <td>{record.dept_name}</td>
                <td>{record.maj_name}</td>
                <td>{record.sinbun_name}</td>
                <td>{record.resource_count}</td>
                <td>{record.self_confirm === 'Y' ? '확인' : '미확인'}</td>
                <td>
                  {!record.scholar_status ? <span className="badge badge-item-status bg-danger">확인필요</span>
                    : record.scholar_status === 'publish' ? <span className="badge badge-item-status badge-success">{STATUS_NAME[record.scholar_status]}</span>
                      : record.scholar_status === 'draft' ? <span className="badge badge-item-status badge-warning">{STATUS_NAME[record.scholar_status]}</span>
                        : record.scholar_status === 'trash' ? <span className="badge badge-item-status badge-dark">{STATUS_NAME[record.scholar_status]}</span>
                          : record.scholar_status === 'unpublish' ? <span className="badge badge-item-status badge-secondary">{STATUS_NAME[record.scholar_status]}</span>
                            : ''
                  }
                </td>
                <td>{getDateYMD(record.input_date)}</td>
                <td>{getDateYMD(record.modified_date)}</td>
            </tr>
        )
    }
}

export default Item;